import request from '../../../utils/Request';
import { Methods } from '../../../config';
import { downloadFile } from '../../../utils/download';

const baseURL = 'varadiMetal/conformity';

const conformityService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  getComponents: (docId, lineNum) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/components/${encodeURIComponent(docId)}/${encodeURIComponent(lineNum)}`,
    });
  },

  printDocument: async (data) => {
    const pdf = await request({
      responseType: 'blob',
      method: Methods.POST,
      resource: `${baseURL}/print`,
      data,
    });

    return downloadFile(pdf, pdf.filename);
  },
};
export default conformityService;
